import { signInUserData } from 'mock/data/authData'
import ApiService from './ApiService'
import { api } from './BaseService'

export async function apiSignIn(data) {
    return {data:{...signInUserData}}
    // return ApiService.fetchData({
    //     url: '/sign-in',
    //     method: 'post',
    //     data,
    // })
}
export const getLogin = async (data) => {
    return await api.post(`/login`,data)
}
export const onLogout = async (data) => {
    return await api.post(`/logout`,data)
}
export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}
